export const formatStats = (headers, play) => {
  let formattedPlay = {};
  headers.forEach((header, index) => {
    formattedPlay[header] = play[index];
  });
  return formattedPlay;
};
